import { FILTER_CONSTANTS } from 'AppConstants';

export const handleSelected = (selectedList = {}, payload = {}) => {
    const { items = [], checked = false } = payload;
    if (!items.length) return { selectedList: {} };

    const updated = { ...selectedList };

    items.forEach((item) => {
        const id = item?.budget_id;
        if (!id) return;
        if (checked) {
            updated[id] = true; // add with true
        } else {
            delete updated[id]; // remove
        }
    });

    return { selectedList: updated };
};

export const resetBudgetFilterValues = (filters = {}) =>
    Object.fromEntries(
        Object.entries(filters).map(([key, filter]) => [
            key,
            {
                ...filter,
                value:
                    filter?.type === FILTER_CONSTANTS.DATE_FILTER
                        ? null
                        : ''
            }
        ])
    );